<template>
    <v-dialog
        v-model="show"
        :confirm-disabled="confirmDisabled"
        @confirm.prevent="create"
        kind="modal"
        status="primary"
        semantic="semantic"
        confirm-text="激活"
        cancel-text="取消"
        class="v-dialog--robot-active"
    >
        <div
            slot="title"
            class="active__title"
        >
            激活应用机器人
        </div>
        <div>
            <v-form
                :model="model"
                size="small"
                kind="desc"
            >
                <v-form-item
                    v-model="formErrors.robotName"
                    :rules="formRules.robotName"
                    name="robotName"
                    label="昵称"
                    required="昵称必填"
                    style="width:100%;"
                    error-placement="top-right"
                >
                    <v-input
                        v-model="model.robotName"
                        name="robotName"
                        placeholder="请输入机器人昵称"
                        style="width:382px;"
                        limit="10"
                        kind="frame"
                    />
                </v-form-item>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import Gateway from '@/utils/Gateway';

export default {
    name: 'OrdinaryRobotActive',
    props: {
        robotId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            show: false,
            model: {
                gptFlag: 0,
                robotName: '',
            },
            formRules: {
                robotName: [
                    { betweenLength: [1, 10], message: '昵称必须在1-10个字符之间' },
                ],
            },
            formErrors: {
                robotName: '',
            },
            confirmDisabled: true,
        };
    },
    watch: {
        model: {
            handler(val) {
                const { robotName } = val;
                this.confirmDisabled = !robotName || robotName.length > 10;
            },
            deep: true,
        },
    },
    methods: {
        open() {
            this.init();
            this.show = true;
        },
        init() {
            this.model = {
                gptFlag: 0,
                robotName: '',
            };
            this.formErrors = {
                robotName: '',
            };
        },
        create() {
            this.confirmDisabled = true;
            Gateway.post(
                '/v1/robot/create',
                { ...this.model, robotId: this.robotId },
                { timeout: 60000 },
            )
                .then(() => {
                    this.confirmDisabled = false;
                    this.show = false;
                    this.$message.success('激活成功');
                    this.$emit('afterActive');
                })
                .catch((message) => this.$message.error(message || '机器人激活失败'));
        },
    },
};
</script>

<style lang="less" scoped>
.v-dialog--robot-active {
    /deep/ .v-descriptions--content {
        position: unset;
    }
    /deep/ .v-description-item {
        width: 100% !important;
        margin: 0;

        &-content {
            width: 100%;
        }

        &--value {
            margin: 0;
            text-align: left !important;
        }
    }
}
</style>
